/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Canvas_Public_Writes_EnabledInputs */



/**
* | output |
* | --- |
* | "Public submissions enabled" |
*
* @param {Artifact_Canvas_Public_Writes_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_canvas_public_writes_enabled = /** @type {((inputs?: Artifact_Canvas_Public_Writes_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Canvas_Public_Writes_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffentliche Einreichungen aktiviert")
	return /** @type {LocalizedString} */ ("Public submissions enabled")
});